import abcLogo from "../photos/abcLogo.svg"
import loginBgLeft from "../photos/loginBgLeft.svg"
import loginBgRight1 from "../photos/loginBgRight1.svg"
import loginBgRight2 from "../photos/loginBgRight2.svg"
import view from "../photos/view.png"
import hide from "../photos/hide.png"
import uploadIcon from "../photos/uploadIcon.svg"
import sortIcon from "../photos/sortIcon.svg"
import emptyIllustration from "../photos/emptyIllustration.svg"
import eye from "../photos/eye.svg"
import edit from "../photos/edit.svg"
import deleteIcon from "../photos/deleteIcon.svg"
import prevArrow from "../photos/prevArrow.svg";
import nextArrow from "../photos/nextArrow.svg";
import searchIcon from "../photos/searchIcon.svg";
import plusIcon from "../photos/plusIcon.svg";
import crossIcon from "../photos/crossIcon.svg";
import uploadIconForModal from "../photos/uploadIconForModal.svg";
import crossIconForUploadFile from "../photos/crossIconForUploadFile.svg";
import profilePic from "../photos/profilePic.svg";
import alertIcon from "../photos/alertIcon.svg";
import logout from "../photos/logout.svg";
import saveIcon from "../photos/saveIcon.svg"
import coinStack from "../photos/coinStack.svg"
import dotBurger from "../photos/dotBurger.svg"
import inactiveIcon from "../photos/inactiveIcon.svg"
import plusIconBlack from "../photos/plusIconBlack.svg"
import closeIcon from "../photos/closeIcon.svg"
import save from '../photos/saveIcon.svg'
import addIcon from '../photos/addIcon.svg'
import alert from '../photos/alertIcon.svg'
import totalRequests from '../photos/totalRequests.svg'
import avgDuration from '../photos/avgDuration.svg'
import successRate from '../photos/successRate.svg'
import cardBgImage from '../photos/cardBgImage.png'
const assetsManager = {
    abcLogo,
    alert,
    loginBgLeft,
    loginBgRight1,
    loginBgRight2,
    view,
    save,
    hide,
    uploadIcon,
    sortIcon,
    emptyIllustration,
    eye,
    edit,
    deleteIcon,
    prevArrow,
    nextArrow,
    searchIcon,
    plusIcon,
    crossIcon,
    uploadIconForModal,
    crossIconForUploadFile,
    profilePic,
    alertIcon,
    logout,
    addIcon,
    closeIcon,
    plusIconBlack,
    inactiveIcon,
    dotBurger,
    coinStack,
    saveIcon,
    totalRequests,
    avgDuration,
    successRate,
    cardBgImage
}

export default assetsManager;